import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import type { IconProps } from '@avodah-inc/types';
import { cn } from '@avodah-inc/ui/utils';

const doorOpenVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
      primary: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type DoorOpenProps = React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof doorOpenVariants> &
  IconProps;

export const DoorOpen = React.forwardRef<SVGSVGElement, DoorOpenProps>(
  (
    {
      className,
      variant,
      viewBox,
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        className={cn(
          doorOpenVariants({
            variant,
            className,
          }),
        )}
        fill={fill}
        height={height}
        ref={ref}
        viewBox={viewBox}
        width={width}
        {...props}
      >
        <path d="M9.186 2.11299C9.24397 2.06614 9.31168 2.03285 9.38418 2.01555C9.45668 1.99825 9.53212 1.99737 9.605 2.01299L16.605 3.51199C16.7167 3.53621 16.8167 3.59795 16.8883 3.68692C16.96 3.77589 16.9991 3.88673 16.999 4.00099V16.001C16.999 16.1154 16.9598 16.2263 16.888 16.3153C16.8161 16.4043 16.7158 16.466 16.604 16.49L9.604 17.99C9.53131 18.0054 9.45609 18.0045 9.38381 17.9872C9.31153 17.97 9.24401 17.9368 9.18616 17.8902C9.12831 17.8435 9.08158 17.7846 9.04938 17.7176C9.01717 17.6506 9.00031 17.5773 9 17.503V2.50299C9.00002 2.42838 9.01673 2.35472 9.04891 2.28741C9.0811 2.2201 9.12794 2.16084 9.186 2.11399V2.11299ZM12.502 10.001C12.502 9.80208 12.423 9.61131 12.2823 9.47066C12.1417 9.33001 11.9509 9.25099 11.752 9.25099C11.5531 9.25099 11.3623 9.33001 11.2217 9.47066C11.081 9.61131 11.002 9.80208 11.002 10.001C11.002 10.1999 11.081 10.3907 11.2217 10.5313C11.3623 10.672 11.5531 10.751 11.752 10.751C11.9509 10.751 12.1417 10.672 12.2823 10.5313C12.423 10.3907 12.502 10.1999 12.502 10.001ZM8.002 3.00299H3.5C3.36739 3.00299 3.24021 3.05567 3.14645 3.14943C3.05268 3.2432 3 3.37038 3 3.50299V16.498C3 16.6306 3.05268 16.7578 3.14645 16.8515C3.24021 16.9453 3.36739 16.998 3.5 16.998H8.002V3.00299Z" />
      </svg>
    );
  },
);

DoorOpen.displayName = 'DoorOpen';
